<div
  class="centermodal__form email-input-container floating-label"
  [class.has-emails]="emails.length > 0"
  [class.has-error]="hasError"
  [class.disabled]="disabled"
  (click)="focusInput()"
  #emailInputContainer
>
  @for (email of emails; track $index) {
    <span class="email-tag">
      {{ email }}
      <button type="button" class="remove-button" (click)="removeEmail($index)" [disabled]="disabled">
        <i class="far fa-times"></i>
      </button>
    </span>
  }
  <div class="email-input-field field" [attr.contenteditable]="!disabled" (keydown)="onKeydown($event)" (blur)="addEmail()" (paste)="onPaste($event)" aria-label="Email input" #emailInput></div>
  <label for="emailInput" class="field__holder">
    {{ label }}
  </label>
  <div class="resize-handle" (mousedown)="initResize($event)"></div>
</div>
@if (hasError) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
}
